import request from './request';

const application_status = {
	async getApplicationStatus(id) {
		const response = await request.get(`/app/applications/id/status?id=${id}`);
		return response;
	},
	async updateApplicationStatus(id, body) {
		const res = await request.patch(`/app/applications/id/status?id=${id}`, body);
		return res;
	},
	async sendPassportForReview(body) {
		const res = await request.post('/app/applications/id/send-passport', body);
		return res;
	},
	async sendItineraryForReview(body) {
		const res = await request.post('/app/applications/id/send-itinerary', body);
		return res;
	},
	async sendInsuranceForReview(body) {
		const res = await request.post('/app/applications/id/send-insurance', body);
		return res;
	}
};

export default application_status;